import React, { Component } from 'react';
import { observer } from 'mobx-react';
import 'Styles/MkMessaging/existentMessageView.scss';
import MkExistentMessageViewStore from 'Stores/mkMessaging/MkExistentMessageViewStore';
import SmrTable from "Components/Common/SmrTable";
import queryString from "query-string";
import { Navigate } from "react-router-dom";
import { ShowModal, GetDateFromString } from "Utils/CommonFunctions";
import MessageBodyAndSettingsContainer from "Components/MkMessaging/messageBodyAndSettingsContainer";
import AppStore from 'Stores/AppStore';
import Helper from 'Utils/Helper';

class MkExistentMessageView extends Component {
    constructor(props) {
        super(props);

        MkExistentMessageViewStore.currentMessageId = queryString.parse(this.props.location.search).messageId;
        MkExistentMessageViewStore.ResetReturnToMessageList();
    }

    componentDidMount() {
        AppStore.OnMainComponentMount(`Информирование пользователей`, 'viewMessage');

        MkExistentMessageViewStore.ShowAlertAfterCancellation = this.props.showAlertAfterCancellation;
    }

    renderTableLine(data) {
        let canceledElement;

        if (data.canceled) {
            canceledElement = <div className='mk-messaging-view-info-canceled-label'>ИСКЛЮЧЕН</div>
        } else if (data.notInformActionAvailable) {
            canceledElement = <button className='red-button'
                onClick={_ => this.ShowCancelMessageModal(data.userLid, data.userName)}>
                Не информировать
            </button>
        }

        let viewedElement =
            data.isTextEmpty
                ? ''
                : data.isTextNotViewed
                    ? 'НЕ ОЗНАКОМЛЕН'
                    : data.isTextViewed
                        ? 'ОЗНАКОМЛЕН'
                        : data.viewDateString
            ;

        return (
            <div className='mk-messaging-view-info smr-table-line'
                key={data.userName}>
                <div className='mk-messaging-view-info-user-name'>{data.userName}</div>
                <div className='mk-messaging-view-info-view-date'>{viewedElement}</div>
                <div className='mk-messaging-view-info-cancel-button'>{canceledElement}</div>
            </div>
        );
    }

    renderHeader() {
        return (
            <div className='mk-messaging-view-info header'>
                <div className='mk-messaging-view-info-user-name'>Пользователи</div>
                <div className='mk-messaging-view-info-view-date'>Ознакомился</div>
                <div className='mk-messaging-view-info-cancel-button' />
            </div>
        )
    }

    ShowMessageDetailsModal() {
        ShowModal({
            className: 'mk-messaging-view-message-info-modal',
            canBeClosed: true,
            header: `Информация о созданном сообщении (ID: ${MkExistentMessageViewStore.messageData.id})`,
            children: <MessageBodyAndSettingsContainer readOnly={true} />,
            buttons: [{
                content: 'Закрыть',
                className: 'blue-button',
                closer: true
            }]
        });
    }

    ShowDeleteMessageModal() {
        ShowModal({
            header: 'Безвозвратное удаление сообщения',
            canBeClosed: true,
            className: 'mk-messaging-remove-message-modal',
            children: 'Внимание! Данное сообщение будет безвозвратно удалено. Пользователи, не получившие сообщение, не смогут с ним ознакомиться. Вы действительно хотите удалить данное сообщение?',
            buttons: [{
                content: 'Отменить',
                closer: true
            }, {
                content: 'Удалить',
                closer: true,
                className: 'blue-button',
                onClick: MkExistentMessageViewStore.DeleteMessage.bind(MkExistentMessageViewStore)
            }]
        });
    }

    ShowCancelMessageModal(userLid, userName) {
        MkExistentMessageViewStore.SetUserInfoForCancelMessageModal(userLid, userName);

        let elementUserName =
            userName.length > 30
                ? <div style={{ textOverflow: "ellipsis", overflow: "hidden" }}>{userName}</div>
                : <span>{userName} </span>
            ;

        ShowModal({
            header: (
                <div className='header-text-container'>
                    {"Отмена отправки сообщения пользователю " + userName}
                </div>
            ),
            canBeClosed: false,
            className: 'mk-messaging-cancel-message-modal',
            children:
                (
                    <div style={{ width: "100%" }}>
                        <span>{"Внимание! Отправка данного сообщения пользователю "}</span>{elementUserName}<span>{" будет отменена. Если пользователь не успеет получить сообщение, он не сможет ознакомиться с его содержанием. Вы действительно хотите отменить отправку данного сообщения?"}</span>
                    </div>
                ),
            buttons: [{
                content: 'Закрыть',
                closer: true
            }, {
                content: 'Отменить отправку',
                className: 'blue-button',
                onClick: MkExistentMessageViewStore.CancelMessage.bind(MkExistentMessageViewStore),
                closer: true
            }]
        });
    }

    render() {
        if (MkExistentMessageViewStore.returnToMessageList)
            return <Navigate to='../mkMessageList' />

        return (
            <div className='mk-messaging-message-list-container'>
                <SmrTable className="mk-message-list"
                    loading={MkExistentMessageViewStore.listLoading}
                    renderTableLine={this.renderTableLine.bind(this)}
                    renderHeader={this.renderHeader.bind(this)}
                    location={this.props.location}
                    getDataPage={MkExistentMessageViewStore.GetViewList.bind(MkExistentMessageViewStore)}
                    setTableStore={MkExistentMessageViewStore.SetTableStore.bind(MkExistentMessageViewStore)}
                    placeholderText="Отсутствуют адресаты для рассылки сообщения"
                    buttonsPanel={{
                        right: <button className={`red-button remove-message-button ${MkExistentMessageViewStore.listLoading ? 'disabled' : ''}`}
                            onClick={this.ShowDeleteMessageModal.bind(this)}>
                            Удалить сообщение
                        </button>,
                        left: <button className={`show-message-button ${MkExistentMessageViewStore.listLoading ? 'disabled' : ''}`}
                            onClick={this.ShowMessageDetailsModal.bind(this)}>
                            Просмотреть сообщение
                        </button>
                    }} />
            </div>
        )
    }
}

export default observer(MkExistentMessageView);